export default __webpack_public_path__ + "static/media/volume_input.9b99306e.png";